module.exports = __webpack_public_path__ + "img/signin_icon_dowork.e6107bc5.png";